<div class="row mb-2">
  <div class="col-12">
    <div class="input-style input-style-always-active no-borders mb-2 shadow-l">
      <input type="text"
             data-id="invididualInput"
             class="form-control validate-name"
             placeholder="Beschreibe hier dein individuelles Ziel">
      <label class="color-primary text-uppercase font-700 font-10"
             style="top: -22px;">Beschreibung</label>
    </div>
  </div>
</div>
<div class="row mb-4">
  <div class="col-12">
    <div class="d-flex fake-input shadow-l"
         data-id="individualItemSelector">
      <div class="align-self-center flex-fill">
        <div class="input-style input-style-always-active no-borders no-icon">
          <label class="color-primary text-uppercase font-700 font-10">ICON</label>
          <img src="assets/icons/routines/apple-2.svg"
               data-id="individual-item"
               class="img-fluid" />
        </div>
      </div>
      <div class="ms-auto ps-3 align-self-center text-center" style="min-width: 50px!important;">
        <i class="fa fa-chevron-right"></i>
      </div>
    </div>
  </div>
</div>
<% if ( false === disableWeeklyFrequence ) {  %>
<div class="row">
  <div class="col-12">
    <div class="d-flex fake-input shadow-l"
         data-id="customWeeklyFrequenceSelector">
      <div class="align-self-center flex-fill">
        <div class="input-style input-style-always-active no-borders no-icon">
          <label class="color-primary text-uppercase font-700 font-10">Häufigkeit</label>
          <div style="padding-top: 4px" class="font-weight-bolder"><div data-id="container-weekly-frequence" style="display: inline-block"><%= weeklyFrequence %></div> x Woche</div>
        </div>
      </div>
      <div class="ms-auto ps-3 align-self-center text-center" style="min-width: 50px!important;">
        <i class="fa fa-chevron-right" style="padding-top: 9px"></i>
      </div>
    </div>
  </div>
</div>
<% }  %>
